import { totoCollarNavigationColor } from './totoCollarIdentity';

export function luminance(hex) {
  const rgb = hex.replace('#', '').match(/../g).map(value => parseInt(value, 16) / 255);
  return rgb.map(v => v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4)
    .reduce((sum, v, i) => sum + v * [.2126, .7152, .0722][i], 0);
}
export function contrast(a, b) {
  const values = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (values[0] + .05) / (values[1] + .05);
}
export function mix(hex, target, amount) {
  const channels = value => value.replace('#', '').match(/../g).map(v => parseInt(v, 16));
  const end = channels(target);
  return '#' + channels(hex).map((v, i) => Math.round(v + (end[i] - v) * amount).toString(16).padStart(2, '0')).join('');
}
export function collarMaterialTokens(user) {
  const source = totoCollarNavigationColor(user);
  // Preserve the actual collar hue. Derive a darker action fill only when
  // normal-sized white labels would otherwise fail WCAG AA contrast.
  let action = source;
  for (let step = 1; contrast(action, '#ffffff') < 4.5 && step <= 20; step += 1) {
    action = mix(source, '#000000', step / 20);
  }
  return {
    '--toto-brand-source': source,
    '--toto-brand-deep': mix(source, '#000000', .8),
    '--toto-brand-dark': mix(source, '#000000', .4),
    '--toto-brand-light': mix(source, '#ffffff', .4),
    '--toto-brand-pale': mix(source, '#ffffff', .8),
    '--toto-brand-action': action,
    '--toto-navigation-color': action,
    '--sculpted-accent': action,
  };
}
